(function () {
    var ATTRIBUTION_COOKIE = "ads_attribution";
    var CLICK_ID_PARAM = "gclid";
    var COOKIE_MAX_AGE_DAYS = 90;
    var MAX_VALUE_LENGTH = 500; // matches the Stripe metadata value limit enforced server-side

    function hasMarketingConsent() {
        return localStorage.getItem("cookiesAccepted") === "true";
    }

    function truncated(value) {
        if (!value) {
            return null;
        }

        value = value.trim().slice(0, MAX_VALUE_LENGTH);
        return value || null;
    }

    // Google Ads auto-tagging appends its own params (gad_source, gad_campaignid,
    // gbraid) instead of standard utm_*/gclid when a campaign relies on auto-tagging
    // rather than a manually-built tracking URL. Fall back to those so auto-tagged
    // ad clicks aren't silently dropped as "no tracking params".
    function readTrackedParams(search) {
        var params = new URLSearchParams(search);
        var found = {};

        var utmSource =
            truncated(params.get("utm_source")) ||
            (params.get("gad_source") ? "google_ads" : null);
        var utmCampaign =
            truncated(params.get("utm_campaign")) ||
            truncated(params.get("gad_campaignid"));
        var utmTerm = truncated(params.get("utm_term"));
        var clickId =
            truncated(params.get("gclid")) || truncated(params.get("gbraid"));

        if (utmSource) {
            found.utm_source = utmSource;
        }
        if (utmCampaign) {
            found.utm_campaign = utmCampaign;
        }
        if (utmTerm) {
            found.utm_term = utmTerm;
        }
        if (clickId) {
            found[CLICK_ID_PARAM] = clickId;
        }

        return found;
    }

    function setCookie(name, value) {
        var maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
        var secure = window.location.protocol === "https:" ? "; Secure" : "";
        document.cookie =
            name +
            "=" +
            encodeURIComponent(value) +
            "; path=/; max-age=" +
            maxAge +
            "; SameSite=Lax" +
            secure;
    }

    function clearCookie(name) {
        var secure = window.location.protocol === "https:" ? "; Secure" : "";
        document.cookie = name + "=; path=/; max-age=0; SameSite=Lax" + secure;
    }

    function readStoredAttribution() {
        var match = document.cookie.match(
            new RegExp("(?:^|; )" + ATTRIBUTION_COOKIE + "=([^;]*)"),
        );
        if (!match) {
            return {};
        }

        try {
            var stored = JSON.parse(decodeURIComponent(match[1]));
            return stored && typeof stored === "object" ? stored : {};
        } catch (e) {
            return {};
        }
    }

    function persistAttribution(values) {
        if (!values || !Object.keys(values).length) {
            return;
        }

        // gclid outlives the utm group: a utm-only visit must never clear it. The utm
        // group is always replaced whole, so its values never mix across visits.
        if (!values[CLICK_ID_PARAM]) {
            var storedClickId = readStoredAttribution()[CLICK_ID_PARAM];
            if (storedClickId) {
                values[CLICK_ID_PARAM] = storedClickId;
            }
        }

        setCookie(ATTRIBUTION_COOKIE, JSON.stringify(values));
    }

    function captureFromCurrentUrl() {
        // The checkout reads this cookie without seeing consent, so it must not outlive it.
        if (!hasMarketingConsent()) {
            clearCookie(ATTRIBUTION_COOKIE);
            return;
        }

        var found = readTrackedParams(window.location.search);
        if (!Object.keys(found).length) {
            return;
        }

        persistAttribution(found);
    }

    captureFromCurrentUrl();
    window.addEventListener("marketingConsentGranted", captureFromCurrentUrl);
})();
